import { createFileRoute } from '@tanstack/react-router';
import { CompanyRepresentatives } from './-components/CompanyRepresentatives';

export const Route = createFileRoute('/_auth/profile/company/_layout/representatives')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CompanyRepresentatives />;
}
